var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-intro"},[_c('div',{staticClass:"new-title"},[_vm._v(_vm._s(_vm.NewsTitle))]),_c('div',{staticClass:"new-content",domProps:{"innerHTML":_vm._s(_vm.NewsContent)}}),(!_vm.NewsContent)?_c('el-empty',{attrs:{"description":"暂无数据"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }